import React, { useState, ReactNode } from "react";
import {
  Layout,
  FileText,
  ClipboardList,
  BarChart2,
  Users,
  Settings,
  HelpCircle,
  ChevronLeft,
  Home,
} from "lucide-react";
import MenuItem from "./MenuItem";
import apiClient from "../utils/appClient";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useProjectContext } from "../context/ProjectContext";
import { useSidebarContext } from "../context/SidebarContext";
import { Project } from "../reducer/ProjectReducer";

interface SidebarProps {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSelect: (menu: string) => void; // Function to handle menu selection
}

const Sidebar: React.FC<SidebarProps> = ({
  sidebarOpen,
  setSidebarOpen,
  onSelect,
}) => {
  const navigate = useNavigate();
  const { state, dispatch } = useProjectContext();
  const [menuOpen, setMenuOpen] = useState<string>("");
  const [showAllProjects, setShowAllProjects] = useState(false);
  const toggleMenu = (menu: string) => {
    setMenuOpen(menuOpen === menu ? "" : menu);
  };
  const { toggleItem } = useSidebarContext();

  const limitedProjects = state.projects.slice(0, 5);
  const Projectlist = (showAllProjects ? state.projects : limitedProjects).map(
    (project) => ({
      id: project.project_id,
      name: project.project_name,
      onClick: () => handleOpenProject(project.project_id, project),
    })
  );

  const handleOpenProject = (projectId: string, project: Project) => {
    // console.log(`Opening project with ID: ${projectId}`);
    dispatch({ type: "SET_CURRENT_PROJECT_ID", payload: projectId });
    dispatch({ type: "SET_SELECTED_PROJECT", payload: project });
    dispatch({ type: "SET_NEW_PROJECT", payload: "" });
    dispatch({ type: "SET_BU_ID", payload: project.bu_id });
    dispatch({ type: "SET_COMPANY_ID", payload: project.company_id });
    fetchAndStoreAllData();
    // Update the key to force a remount
    // navigate("/dashboard/projectcreationform");
    // navigate("/dashboard/assessment");
    navigate("/device");
    // close dropdown when selected any item
    // console.log(projectId);
    localStorage.setItem("lastAssessment", projectId);
    toggleItem("my-projects");
  };

  const fetchAndStoreAllData = async () => {
    console.log("Get Data");
  };

  const subTasks = [
    {
      id: "1",
      name: "Project Creation",
      onClick: () => onSelect("ProjectCreationForm"),
    },
    {
      id: "2",
      name: "Device Health",
      onClick: () => onSelect("Device Health Page"),
    },

    {
      id: "3",
      name: "CBOM Records",
      onClick: () => onSelect("CBOM Records"),
    },
    // {
    //   id: "4",
    //   name: "Sensor Agent",
    //   onClick: () => onSelect("Sensor Agent"),
    // },
    {
      id: "5",
      name: "Overall Summary",
      onClick: () => onSelect("Overall Summary"),
    },
  ];

  return (
    <div
      className={`flex flex-col h-full ${
        sidebarOpen ? "bg-white" : "bg-transparent"
      } rounded-lg p-1 mr-0 overflow-y-auto relative transition-all duration-300 ease-in-out`}
    >
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className={`absolute top-2 right-0 xl:rounded-tl-lg rounded-tl-md xl:rounded-bl-lg rounded-bl-md px-[1px] py-[4px] xl:px-[2px] xl:py-[6px] transition-transform duration-300 ${
          !sidebarOpen
            ? "rotate-180 xl:rounded-tr-lg rounded-tr-md xl:rounded-br-lg rounded-br-md text-custom-bluenew bg-white"
            : "bg-custom-bluenew text-white"
        }`}
      >
        <ChevronLeft className="xl:h-5 xl:w-5 h-4 w-4" />
      </button>

      <div
        className={`transition-opacity duration-300 ${
          !sidebarOpen ? "opacity-0 h-0 overflow-hidden" : "opacity-100"
        }`}
      >
        <div className="p-4">
          <div className="flex items-baseline space-x-1">
            <h1
              className="text-2xl font-bold text-custom-blue7 cursor-pointer"
              onClick={() => navigate("/")}
            >
              Discovery
            </h1>
            {/* <span className="text-xs text-custom-blue7">v0.1</span> */}
          </div>
          <div className="mt-4 flex items-center space-x-2 p-2 shadow-lg bg-custom-blue0 rounded">
            <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <Users className="w-4 h-4 bg-custom-blue1" />
            </div>
            <div>
              <p className="text-sm font-medium text-custom-blue7">Admin</p>
              <p className="text-xs text-custom-blue7">Project Manager</p>
            </div>
          </div>
        </div>

        <nav className="mt-4 flex-1">
          {/* Menu Items */}
          <MenuItem
            id="home"
            icon={<Home />}
            text="Home"
            onClick={() => onSelect("Home")}
          />
          <MenuItem
            id="my-projects"
            icon={<FileText className="xl:h-6 xl:w-6 h-5 w-5" />}
            text="My Projects"
            onClick={() => onSelect("")}
            subTasks={[
              ...Projectlist,
              ...(state.projects.length > 5
                ? showAllProjects
                  ? [
                      {
                        id: "View Less",
                        name: "View Less",
                        onClick: () => setShowAllProjects(false),
                      },
                    ]
                  : [
                      {
                        id: "Show All",
                        name: "Show All",
                        onClick: () => setShowAllProjects(true),
                      },
                    ]
                : []),
            ]}
            showArrow={true}
            isDropdown={true}
          />
          {state.currentProjectID && (
            <MenuItem
              id="current-project"
              icon={<ClipboardList className="xl:h-6 xl:w-6 h-5 w-5" />}
              text="Current Project"
              onClick={() => {
                // console.log("Current Project clicked");
                // console.log("");
              }}
              subTasks={subTasks}
              showArrow={true}
              isDropdown={true}
            />
          )}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
